export default class { 

    'api-Version' = '';

    mapToDto(headers) {
        
        this['api-Version'] = headers;
        
        return this;
    }
}